<template>
    <div v-if="!noMonogramError" class="design-text">
    
        <div class="design-side">
            <div
                v-for="(monogramDesignFromList, index) in this.uStore.userDesigns[store.currentEditingProps.productId
                    ].designs[store.currentEditingProps.variantId].imgVariants[store.currentEditingProps.imageToPreview].monograms"
                    :key="index"
                class="elements-container"
            >
                <div :class="store.currentEditingProps.currentPreview == 'monogram' && store.currentEditingProps.currentPreviewIndex == index ? 'element-div ele-div-active' : 'element-div'">
                    <div class="ele-line">
                        <div class="ele-title-line">
                            <span class="ele-title">
                                <span class="ele-title-txt">Choose Mon</span>
                                <!-- <input class="ele-input" type="text" 
                                        :placeholder="'Search Design'"
                                        v-model="searchArtText" @change="getArtBySearch()"/> -->
                            </span>
                            <span class="remove-container" @click.stop="delMonogram(index)">
                                <img class="remove-img" src="../../../public/Icons-DeleteBlackIcon.png"/>
                                <span class="remove-title">Remove</span>
                            </span>
                        </div>
                        <div class="gallery-elements">
                            <div
                                v-for="(monogram, monogramIndex) in store.getAllMonogramsWithoutMaterials()"
                                :key="monogramIndex"
                                @click="changeMonogram(monogram, index)"
                                :class="monogramDesignFromList.monogramID == monogram.monogramID ? 'gallery-item gallery-item-active' : 'gallery-item'"
                                >


                                <!-- :colorLeftChar="monogram.leftChar.defaultColors"
                                    :colorMiddleChar="
                                    monogram.middleChar != null
                                        ? monogram.middleChar.defaultColors
                                        : null
                                    "
                                    :colorRightChar="monogram.rightChar.defaultColors" -->
                                <MonogramPreview
                                    :monogramObj="monogram"
                                    :colorLeftChar="monogram.leftChar.defaultColors"
                                    :colorMiddleChar="
                                        monogram.numOfCharacters == '3'
                                        ? monogram.middleChar.defaultColors
                                        : null
                                    "
                                    :colorRightChar="monogram.rightChar.defaultColors"
                                    :char1="'A'"
                                    :char2="'B'"
                                    :char3="monogram.numOfCharacters == '2' ? 'B' : 'C'"
                                    :align="monogram.defaultAlignType"
                                    :distance1="monogram.distance1"
                                    :distance2="monogram.distance2"
                                    :dpi="store.currentEditingProps.dpi"
                                    :left="getMonogramTopLeft(monogram, 45, 45, 'A', 'B',
                                        monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).left"
                                    :top="getMonogramTopLeft(monogram, 45, 45, 'A', 'B',
                                        monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).top"
                                    :dh="35"
                                    :dw="35"
                                >
                                </MonogramPreview>
                                </div>
                        </div>
                        <div class="edit-container-line">
                            <div class="element-line-1">
                                <div class="ele-title-line">
                                <span class="ele-title">
                                    <span class="ele-title-txt">Enter Letters</span>
                                </span>                            
                                </div>
                                <div class="ele-input-container">
                                    <div class="input-with-error">
                                        <input class="ele-input small-input" type="text"
                                            :min="1"
                                            :max="uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[index].numOfCharacters"
                                            :value="
                                            uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                index
                                            ].leftChar"
                                            :maxlength="1"
                                            @input="(e) => {
                                                const isValid = validateAndUpdateChar(e.target.value, index, 'leftChar');
                                                if (isValid) {
                                                    uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].leftChar = e.target.value;
                                                    updateMonogramLocation(index);
                                                } else {
                                                    e.target.value = uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].leftChar;
                                                }
                                            }" />
                                        <div v-if="validationErrors.leftChar[index]" class="error-message">
                                            {{ validationErrors.leftChar[index] }}
                                        </div>
                                    </div>
                                    <div v-if="uStore.userDesigns[store.currentEditingProps.productId].designs[
                                            store.currentEditingProps.variantId
                                        ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                            index
                                        ].middleChar != null" class="input-with-error">
                                        <input class="ele-input small-input middle-input" type="text"
                                            :min="1"
                                            :max="uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[index].numOfCharacters"
                                            :value="
                                            uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                index
                                            ].middleChar
                                            "
                                            :maxlength="1"
                                            @input="(e) => {
                                                const isValid = validateAndUpdateChar(e.target.value, index, 'middleChar');
                                                if (isValid) {
                                                    uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].middleChar = e.target.value;
                                                    updateMonogramLocation(index);
                                                } else {
                                                    e.target.value = uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].middleChar;
                                                }
                                            }" />
                                        <div v-if="validationErrors.middleChar[index]" class="error-message">
                                            {{ validationErrors.middleChar[index] }}
                                        </div>
                                    </div>
                                    <div class="input-with-error">
                                        <input class="ele-input small-input middle-input" type="text"
                                            :min="1"
                                            :max="uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[index].numOfCharacters"
                                            :value="
                                            uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                store.currentEditingProps.variantId
                                            ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                index
                                            ].rightChar
                                            "
                                            @input="(e) => {
                                                const isValid = validateAndUpdateChar(e.target.value, index, 'rightChar');
                                                if (isValid) {
                                                    uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].rightChar = e.target.value;
                                                    updateMonogramLocation(index);
                                                } else {
                                                    e.target.value = uStore.userDesigns[store.currentEditingProps.productId].designs[
                                                        store.currentEditingProps.variantId
                                                    ].imgVariants[store.currentEditingProps.imageToPreview].monograms[
                                                        index
                                                    ].rightChar;
                                                }
                                            }" />
                                        <div v-if="validationErrors.rightChar[index]" class="error-message">
                                            {{ validationErrors.rightChar[index] }}
                                        </div>
                                    </div>
                                    <span class="change-size-container">
                                        <span>+</span>
                                        <span>
                                            <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.846 7.83H2.59L1.806 10H0.462L3.99 0.298H5.46L8.974 10H7.63L6.846 7.83ZM6.482 6.794L4.718 1.866L2.954 6.794H6.482ZM14.8126 8.295H11.4686L10.8526 10H9.79659L12.5686 2.377H13.7236L16.4846 10H15.4286L14.8126 8.295ZM14.5266 7.481L13.1406 3.609L11.7546 7.481H14.5266Z" fill="#2D2D2D"/>
                                            </svg>
                                        </span>
                                        <span>-</span>
                                    </span>
                                </div>
                            </div>

                            <div class="element-line-1">
                                {{ this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].multiColor == true ? 'Multi Colors' : 'One Color'}}
                                <span class="edit-colors-container">
                                    <span :class="!this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].multiColor ? 'one-color color-btn active-color-btn' : 'one-color color-btn'" @click="changeMultiColor(false, index)">ABC</span>
                                    <span :class="this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].multiColor == true ? 'multi-colors color-btn active-color-btn' : 'multi-colors color-btn'" @click="changeMultiColor(true, index)">
                                        <span class="letter-1">A</span>
                                        <span class="letter-2">B</span>
                                        <span class="letter-3">C</span>
                                    </span>
                                </span>
                                <div class="select-colors-container" v-if="this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].multiColor == true">
                                    <div
                                        v-for="(layer, colorIndex) in this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].colorsLeftChar"
                                        :key="colorIndex"
                                    >
                                        <SelectColor v-model="this.uStore.userDesigns[
                                            store.currentEditingProps.productId
                                            ].designs[store.currentEditingProps.variantId].imgVariants[
                                            store.currentEditingProps.imageToPreview
                                            ].monograms[index].colorsLeftChar[colorIndex]">
                                        </SelectColor>
                                    </div>
                                    <template v-if="this.uStore.userDesigns[
                                            store.currentEditingProps.productId
                                            ].designs[store.currentEditingProps.variantId].imgVariants[
                                            store.currentEditingProps.imageToPreview
                                            ].monograms[index].numOfCharacters == '3'">
                                        <div
                                            v-for="(layer, colorIndex) in this.uStore.userDesigns[
                                            store.currentEditingProps.productId
                                            ].designs[store.currentEditingProps.variantId].imgVariants[
                                            store.currentEditingProps.imageToPreview
                                            ].monograms[index].colorsMiddleChar"
                                            :key="colorIndex"
                                        >
                                            <SelectColor v-model="this.uStore.userDesigns[
                                                store.currentEditingProps.productId
                                                ].designs[store.currentEditingProps.variantId].imgVariants[
                                                store.currentEditingProps.imageToPreview
                                                ].monograms[index].colorsMiddleChar[colorIndex]">
                                            </SelectColor>
                                        </div>
                                    </template>
                                    <div
                                        v-for="(layer, colorIndex) in this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].colorsRightChar"
                                        :key="colorIndex"
                                    >
                                        <SelectColor v-model="this.uStore.userDesigns[
                                            store.currentEditingProps.productId
                                            ].designs[store.currentEditingProps.variantId].imgVariants[
                                            store.currentEditingProps.imageToPreview
                                            ].monograms[index].colorsRightChar[colorIndex]">
                                        </SelectColor>
                                    </div>
                                </div>
                                <div class="select-colors-container" v-else-if="!this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].multiColor">
                                    <div
                                        v-for="(layer, colorIndex) in this.uStore.userDesigns[
                                        store.currentEditingProps.productId
                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                        store.currentEditingProps.imageToPreview
                                        ].monograms[index].colorsLeftChar"
                                        :key="colorIndex"
                                    >
                                    <!-- צריך לעדכן פה את הצבעים של כל האותית לפי מה שבחר פה, ואם יש כמה שכבות להתייחס לזה גם -->
                                        <SelectColor :model-value="this.uStore.userDesigns[
                                            store.currentEditingProps.productId
                                            ].designs[store.currentEditingProps.variantId].imgVariants[
                                            store.currentEditingProps.imageToPreview
                                            ].monograms[index].colorsLeftChar[colorIndex]"
                                            
                                                @update:modelValue="(value) => {
                                                    this.uStore.userDesigns[
                                                        store.currentEditingProps.productId
                                                        ].designs[store.currentEditingProps.variantId].imgVariants[
                                                        store.currentEditingProps.imageToPreview
                                                        ].monograms[index].colorsLeftChar[colorIndex] = value;
                                                    changeMultiColor(false, index);
                                                }
                                            "
                                            >
                                        </SelectColor>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="edit-container-line">
                            <div class="form-outline distance-container">
                                <div class="edit-distance">
                                    <label class="lableInOpenLine">
                                        {{
                                            getCurrentMonogram(index).leftChar
                                        }} || {{
                                            getCurrentMonogram(index).middleChar != null ? getCurrentMonogram(index).middleChar : getCurrentMonogram(index).rightChar
                                        }}
                                    </label>
                                    <div class="form-control range-form">
                                        <span class="cancle-distance" title="Cancle Distance" @click="cancleDistance('1', index)">
                                            <img
                                            :src="store.baseIconsURL + '//Icons-ResetDistanceIcon.png'"
                                            style="height: 17px;"
                                            />
                                        </span>
                                        <MDBRange
                                        class="form-range"
                                        :min="0"
                                        :max="getMaxDistance(index)"
                                        v-model="getCurrentMonogram(index).distance1"
                                        @change="updateMonogramLocation(index)"
                                        />
                                    </div>
                                </div>
                                <div v-if="getCurrentMonogram(index).middleChar != null" class="edit-distance">
                                    <label class="lableInOpenLine" style="width: 19%; font-size: 14px;"
                                    >
                                        {{
                                            getCurrentMonogram(index).middleChar
                                        }} || {{
                                            getCurrentMonogram(index).rightChar
                                        }}
                                    </label>
                                    <div class="form-control range-form">
                                        <span class="cancle-distance" title="Reset Distance" @click="cancleDistance('2', index)">
                                            <img
                                            :src="store.baseIconsURL + '//Icons-ResetDistanceIcon.png'"
                                            style="height: 17px;"
                                            />
                                        </span>
                                        <MDBRange
                                            class="form-range"
                                            :min="0"
                                            :max="getMaxDistance(index)"
                                            v-model="getCurrentMonogram(index).distance2"
                                            @change="updateMonogramLocation(index)"
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div class="edit-align">
                                <label class="align-title">Align</label>
                                <div class="align-container">
                                    <div
                                        :class="
                                            getCurrentMonogram(index).align == 'bottom'
                                            ? 'active-align'
                                            : 'align-option'
                                        "
                                        title="align bottom"
                                    >
                                        <img src="../../../public/Icons-Align-bottom.svg"
                                            @click="changeAlign('bottom', index)"/>
                                    </div>
                                    <div
                                        :class="
                                            getCurrentMonogram(index).align == 'center'
                                            ? 'active-align'
                                            : 'align-option'
                                        "
                                        title="align center"
                                        >
                                        <img src="../../../public/Icons-Align-center.svg"
                                            @click="changeAlign('center', index)"/>
                                    </div>
                                    <div
                                        :class="
                                            getCurrentMonogram(index).align == 'top'
                                            ? 'active-align'
                                            : 'align-option'
                                        "
                                        title="align top"
                                        >
                                        <img src="../../../public/Icons-Align-top.svg"
                                            @click="changeAlign('top', index)"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                    </div>
                </div>
            </div>
            <button class="btn-add-element" title="Add New Monogram" @click="addMonogramToDesign()">
                +Add New Monogram
            </button>
        <!-- </div> -->
    </div>
    <div v-else class="design-text">
        <span style="color:red; text-align: center;">No available monograms to add.</span>
    </div>
</template>

<script>
import { designerStore } from "@/stores/designerStore";
import { userStore } from "@/stores/userStore";
import MonogramPreview from "../MonogramPreview.vue";
import SelectColor from "../SelectColor.vue";
import {
    MDBRange,
} from "mdb-vue-ui-kit";

export default {
    components: {
        MonogramPreview,
        SelectColor,
        MDBRange,
    },
    setup() {
        const store = designerStore();
        const uStore = userStore();
        return {
            store,
            uStore,
        };
    },
    data() {
      return {
        noMonogramError: false,
        validationErrors: {
          leftChar: {},
          middleChar: {},
          rightChar: {}
        }
      }
    },
    props: {
        changeStyleByRef: {
            type: Function,
            required: true
        },
        increaseTextSize: {
            type: Function,
            required: true
        },
        decreaseTextSize: {
            type: Function,
            required: true
        },
        changeArc: {
            type: Function,
            required: true
        },
        resetArc: {
            type: Function,
            required: true
        },
    },
    mounted() {
        if(this.uStore.userDesigns[this.store.currentEditingProps.productId]
        .designs[this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms.length == 0) {
            this.addMonogramToDesign();
        }
    },
      
    // props: ["textPreview", "imageToPreview", "productId", "variantId", "currentPreviewIndex", "currentPreview", "dpi"],
    // },
    methods: {
        validateChar(char, monogramIndex, charType) {
            // פונקציה לבדיקת תקינות האות - למלא על ידי המשתמשת
            // charType: 'leftChar', 'middleChar', 'rightChar'
            // מחזירה true אם האות תקינה, false אם לא
            var fontId = 0;
            var fontSizeId = 0;
            var mono = this.store.allMonograms.value[this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                        this.store.currentEditingProps.variantId
                    ].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                        monogramIndex
                    ].monogramID];
            switch(charType) {
                case 'leftChar':
                    fontId = mono.leftChar.fontID;                    
                    fontSizeId = mono.leftChar.fontSizeID;

                    break;
                case 'middleChar':
                    fontId = mono.middleChar.fontID;
                    fontSizeId = mono.middleChar.fontSizeID;
                    break;
                case 'rightChar':
                    fontId = mono.rightChar.fontID;
                    fontSizeId = mono.rightChar.fontSizeID;
                    break;
                default:
                    return false;
            }
            
            if (this.store.allFonts.value[fontId].sizes[fontSizeId]
            .DictCharacters[char] == undefined) {
                return false;
            }
            return true;

            // כאן צריך להוסיף את הלוגיקה לבדיקה אם האות קיימת בפונט הנוכחי
            // לדוגמה:
            // var currentMonogram = this.getCurrentMonogram(monogramIndex);
            // var availableChars = // לקבל רשימת אותיות זמינות מהפונט
            // return availableChars.includes(char.toUpperCase());
    },
        
        validateAndUpdateChar(char, monogramIndex, charType) {
            const isValid = this.validateChar(char, monogramIndex, charType);
            
            if (!isValid) {
                this.validationErrors[charType][monogramIndex] = 'Invalid char';
                // הסרת הודעת השגיאה אחרי 3 שניות
                setTimeout(() => {
                    delete this.validationErrors[charType][monogramIndex];
                }, 3000);
            } else {
                delete this.validationErrors[charType][monogramIndex];
            }
            
            return isValid;
        },
        
        getMaxValue(){
          this.filterInput();
          
        },
        filterInput(event, index) {
                     let font=Object.keys(this.store.allFonts.value[ this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                          this.store.currentEditingProps.variantId
                        ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                          index
                        ].fontID].sizes["1"].DictCharacters);
                        const characterString = font.join('');
                        const regex = new RegExp(`[^${characterString}]`, 'g');
      const input = event.target.value;
      if (regex.test(input)) {
        event.target.value = input.replace(regex, '');
        return "";
     }
      
     return input
    }
,
        getCurrentMonogram(index) {
        return this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
            .imgVariants[this.store.currentEditingProps.imageToPreview].monograms[index];
        },  
        async addMonogramToDesign() {
            // if(this.store.currentEditingProps.isDesignDst == false) {
            //     this.noMonogramError = true;
            //     return;
            // }
            var monogram = this.store.getAllMonogramsWithoutMaterials()[0];
            console.log("monogram.multiColor:", monogram.multiColor);
            if(monogram != null) {
            this.noMonogramError = false;
            (this.monogramPreview = {
                // imageName: this.store.currentEditingProps.imageToPreview,
                monogramID: monogram.monogramID,
                // colors: Object.values(this.store.allArts.value)[0].defaultColors.map(
                // (x) => x
                // ),
                numOfCharacters: monogram.numOfCharacters,
                multiColor: monogram.multiColor == true ? true : false,
                location: { x: 0, y: 0, arc: 0 },
                align: monogram.defaultAlignType,
                distance1: monogram.distance1,
                distance2: monogram.distance2,
                leftChar: monogram.leftChar,
                middleChar: monogram.middleChar,
                rightChar: monogram.rightChar,
                colorsLeftChar: [...monogram.leftChar.defaultColors],
                colorsMiddleChar:
                monogram.numOfCharacters != "2"
                    ? monogram.middleChar.defaultColors.map((x) => x)
                    : null,
                colorsRightChar: monogram.rightChar.defaultColors.map(
                (x) => x
                ),
            }),
                this.store.addMonogramToDesign(
                this.monogramPreview
                );
            this.store.currentEditingProps.currentPreviewIndex =
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants[this.store.currentEditingProps.imageToPreview].monograms.length - 1;
                await this.changeStyleByRef('monogram');
        } else {
            this.noMonogramError = true;
            }
        },        
        changeMonogram(monogram, index) {
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].monogramID = monogram.monogramID;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].leftChar = 'A';
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].numOfCharacters = monogram.numOfCharacters;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].align = monogram.defaultAlignType;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].multiColor = monogram.multiColor;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].middleChar = monogram.numOfCharacters != "2" ? 'B' : null;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].rightChar = monogram.numOfCharacters == "2" ? 'B' : 'C';
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].colorsLeftChar = monogram.leftChar.defaultColors.map((x) => x);
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].colorsMiddleChar =
                monogram.middleChar != null
                ? monogram.middleChar.defaultColors.map((x) => x)
                : null;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index].colorsRightChar = monogram.rightChar.defaultColors.map((x) => x);
            //distance 1 is correct
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index
            ].distance1 = monogram.distance1 || 0;
            
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[
                index
            ].distance2 =
                monogram.numOfCharacters != "2"
                ? monogram.distance2 != null
                    ? monogram.distance2
                    : 0
                : null;
            this.updateMonogramLocation(index);
            // this.changeSelectedMonogram = false;
        },
        changeMultiColor(multiColor, index) {
            var monoObj = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[index];
            monoObj.multiColor = multiColor;
            if(monoObj.multiColor == false) {
                //משנה את שתי או שלושת הצבעים להיות כמו השמאלי
                if(monoObj.numOfCharacters == '3') {
                    this.copyColors(monoObj.colorsMiddleChar, monoObj.colorsLeftChar);
                }
                this.copyColors(monoObj.colorsRightChar, monoObj.colorsLeftChar);                                        
            } else {
                // במצב רב צבעי - החזר את צבעי ברירת המחדל של המונוגרם המקורי
                var originalMonogram = this.store.allMonograms.value[monoObj.monogramID];
                
                // leftChar - השתמש בצבעי ברירת המחדל של המונוגרם
                if (originalMonogram.leftChar && originalMonogram.leftChar.defaultColors) {
                    monoObj.colorsLeftChar = [...originalMonogram.leftChar.defaultColors];
                }
                
                // middleChar
                if (monoObj.numOfCharacters == '3' && originalMonogram.middleChar && originalMonogram.middleChar.defaultColors) {
                    monoObj.colorsMiddleChar = [...originalMonogram.middleChar.defaultColors];
                }
                
                // rightChar
                if (originalMonogram.rightChar && originalMonogram.rightChar.defaultColors) {
                    monoObj.colorsRightChar = [...originalMonogram.rightChar.defaultColors];
                }
            }
        },
        copyColors(oldColors, newColors) {
            // var index = 0;
            for(var i = 0; i < oldColors.length; i++) {
                oldColors[i] = newColors[i % newColors.length];
                // index++;
            }
        },
        changeAlign(align, index) {
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[index].align = align;
            this.updateMonogramLocation(index);
        },
        cancleDistance(distanceNum, index) {
            var monoDesign =  this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].monograms[index];
            var mono = this.store.getAllMonogramsWithoutMaterials()[monoDesign.monogramID];
            if(distanceNum == "1" ) {this.getCurrentMonogram(index).distance1 = mono.distance1;}
            else if(distanceNum == "2" ) {this.getCurrentMonogram(index).distance2 = mono.distance2;}
            this.updateMonogramLocation(index);
        },
        delMonogram(index) {
            this.store.delMonogram(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.imageToPreview,
                index
            );
            this.store.currentEditingProps.currentPreviewIndex = -1;
        },
        getMonogramTopLeft(monogram, height, width, char1, char2, char3, distance1, distance2) {
            var monoHeight = this.store.getMaxMonogramHeight(monogram, char1, char2, char3) * (this.store.currentEditingProps.dpi / 254.0);
            var monoWidth = this.store.getMonogramWidth(monogram, char1, char2, char3, distance1, distance2) * (this.store.currentEditingProps.dpi / 254.0);
            var top = 0;
            var left = 0;
            if(monoHeight > monoWidth) {
                top = 0;
                left = (width - (monoWidth * (height / monoHeight))) / 2;
            } else if(monoWidth > monoHeight) {
                top = (height - (monoHeight * (width / monoWidth))) / 2;
                left = 0;
            } else {
                top = 0;
                left = 0;
            }
            return {
                top: top,
                left: left
            };
        },
        getMaxDistance(index) {
            var curMonogramDesign = this.getCurrentMonogram(index);
            var curMonogram = this.store.allMonograms.value[curMonogramDesign.monogramID];
            return (
                this.store.getMaxMonogramHeight(
                curMonogram,
                curMonogramDesign.leftChar,
                curMonogramDesign.middleChar,
                curMonogramDesign.rightChar
                ) / 2
            );
        },
        updateMonogramLocation(index) {
            var monogramObj =
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants[this.store.currentEditingProps.imageToPreview].monograms[index];
            var result = this.store.getMonogramLocation(
                this.store.allMonograms.value[monogramObj.monogramID],
                monogramObj.distance1,
                monogramObj.distance2,
                monogramObj.align,
                monogramObj.leftChar,
                monogramObj.middleChar,
                monogramObj.rightChar,
                monogramObj.location[0] ? monogramObj.location[0].x : 0,
                monogramObj.location[0] ? monogramObj.location[0].y : 0
            );
            monogramObj.location = result.location;
            monogramObj.dragSize = result.dragSize;

            monogramObj.dragTransform.width = monogramObj.dragSize.w * this.store.currentEditingProps.dpi / 254;
            monogramObj.dragTransform.height = monogramObj.dragSize.h * this.store.currentEditingProps.dpi / 254;

            this.changeStyleByRef('monogram');
        },
    

    }
};
</script>

<style scoped>
input.small-input {
    width: 35px;
    text-align: center;
}
input.middle-input {
    border-radius: 0px !important;
    border-left: none !important;
}
.align-title {
    margin-right: 15px;
    font-size: 16px;
}
.align-container {
    display: flex;
    gap: 10px;
}
.edit-container-line {
    display: flex;
}
.distance-container {
    display: flex;
}
.edit-distance {
    display: grid;
}
.edit-align {
    display: grid;
}
.letter-1 {
    color: #72984F;
}
.letter-2 {
    color: #FF3535;
}
.letter-3 {
    color: #561BFF;
}
.color-btn {
    border: solid 1px;
    padding: 1px 6px 1px 6px;
    font-size: 13px;
}
.one-color {
    border-radius: 1rem 0px 0px 1rem;
}
.multi-colors {    
    border-radius: 0px 1rem 1rem 0px;
}
.active-color-btn {
    background: #EDEDED;
}
.select-colors-container {
    display: flex;
    gap: 20px;
}
.range-form {
    display: flex;
    gap: 5px;
    width: auto;
    align-items: normal;
    background-color: rgb(249, 249, 249);
}
.gallery-elements {
    display: flex;
    gap: 10px;
}
.gallery-item {
    background: #EDEDED;
}
.gallery-item-active {
    border: 1px solid #72984F;
}
.active-align {
    border: 1px solid #72984F;
}
.input-with-error {
    position: relative;
    display: inline-block;
}
.error-message {
    color: red;
    font-size: 10px;
    position: absolute;
    top: 100%;
    left: 0;
    white-space: nowrap;
    z-index: 10;
}

</style>